import React from "react";
import { useViewerStore } from "../../stores/viewerStore";
import { TOOLBAR_ICON_CLASS } from "./toolbarConstants";
import { ToolButton } from "./toolbarUi";
import { getPriorityItemKeys, isPriorityItemActive, priorityItems } from "./toolbarItems";

function SelectionPriorityPrimary({ active, onClick, items }) {
  const scenePrioritySelection = useViewerStore((state) => state.scenePrioritySelection);
  const activeItem =
    items.find((item) => isPriorityItemActive(item, scenePrioritySelection)) ??
    items[0] ??
    priorityItems[0];
  const ActiveIcon = activeItem.PrimaryIcon ?? activeItem.Icon;

  return (
    <ToolButton active={active} label="Selection Priority" onClick={onClick}>
      <ActiveIcon className={TOOLBAR_ICON_CLASS} />
    </ToolButton>
  );
}

function SelectionPrioritySubmenu({ items, scenePresence }) {
  const scenePrioritySelection = useViewerStore((state) => state.scenePrioritySelection);
  const setScenePrioritySelection = useViewerStore(
    (state) => state.actions.setScenePrioritySelection
  );

  return (
    <>
      {items.map(({ key, storeKeys, presenceKey, label, Icon }) => {
        const item = { key, storeKeys };
        const keys = getPriorityItemKeys(item);
        const active = isPriorityItemActive(item, scenePrioritySelection);
        const hasSceneItems = scenePresence[presenceKey] !== false;
        return (
          <ToolButton
            key={key}
            active={active}
            className={
              active
                ? ""
                : hasSceneItems
                  ? "viewport-toolbar-button--has-scene-items"
                  : "viewport-toolbar-button--empty-scene"
            }
            label={label}
            onClick={() => setScenePrioritySelection(keys, true)}
            showOffSlash={!active && !hasSceneItems}
          >
            <Icon className={TOOLBAR_ICON_CLASS} />
          </ToolButton>
        );
      })}
    </>
  );
}

export { SelectionPriorityPrimary, SelectionPrioritySubmenu };
